<script>
export default {
  components: {},
  props: {
    content: {
      type: [String, Number],
      required: true,
    },
  },
  validations: {},
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      showAltMessage: false,
    };
  },
  computed: {},
  mounted() {
    // Adiciona o listener para o evento de redimensionamento da tela
    window.addEventListener('resize', this.updateWindowDimensions);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  },
  methods: {
    updateWindowDimensions() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<template>
  <div
    class="max-h-full max-w-full h-full w-full text-center flex justify-center items-center"
  >
    <img
      v-if="!showAltMessage"
      class="max-h-full w-full object-contain"
      :src="content"
      @error="showAltMessage = true"
    />
    <div v-else class="text-red-600 text-xs">
      ⚠️ {{ $t('REPORT.DATA_FETCHING_FAILED') }}
    </div>
  </div>
</template>
